import { render } from "./ProjetcPage.vue?vue&type=template&id=cb3009e6&scoped=true"
import script from "./ProjetcPage.vue?vue&type=script&lang=js"
export * from "./ProjetcPage.vue?vue&type=script&lang=js"

import "./ProjetcPage.vue?vue&type=style&index=0&id=cb3009e6&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-cb3009e6"

export default script